module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"UrakkaDiili","short_name":"UD","start_url":"/","background_color":"#242267","theme_color":"#242267","display":"minimal-ui","icon":"/opt/build/repo/web/static/icon.svg","icon_options":{"purpose":"maskable"},"cache_busting_mode":"none","legacy":true,"theme_color_in_head":true,"crossOrigin":"anonymous","include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[],"precachePages":["/*"]},
    },{
      plugin: require('../node_modules/@piwikpro/gatsby-plugin-piwik-pro/gatsby-browser.js'),
      options: {"plugins":[],"pluginEnabled":true,"containerUrl":"https://urakkadiili.containers.piwik.pro","containerId":"f174d23b-258d-46c0-aacf-6cb5d2124fca"},
    },{
      plugin: require('../gatsby-browser.jsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
